export default __webpack_public_path__ + "static/media/SKODA.59ffd664.png";